import { createActions } from 'redux-actions';

export default createActions(
  {
    // TODO
  },
  { prefix: 'MISSION/DJI' }
);
